<template>
  <b-modal id="modal-categories" hide-footer scrollable>
    <template #modal-header>
      <h4>
        {{ data.id === null ? $t("categories.new") : $t("categories.edit") }}
      </h4>
    </template>
    <ValidationObserver v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(onSubmit)">
        <div class="new-user-info">
          <b-row class="justify-content-md-center">
            <b-form-group
              class="col-md-12"
              :label="$t('categories.name')"
              label-for="name"
            >
              <ValidationProvider
                :name="$t('categories.name')"
                rules="required"
                v-slot="{ errors }"
              >
                <b-form-input
                  v-model="data.name"
                  type="text"
                  :placeholder="$t('categories.name')"
                  :class="errors.length > 0 ? ' is-invalid' : ''"
                >
                </b-form-input>
                <div class="invalid-feedback">
                  <span>{{ errors[0] }}</span>
                </div>
              </ValidationProvider>
            </b-form-group>
          </b-row>
          <hr />
          <b-button
            :disabled="categoriesLoading"
            variant="success"
            class="float-right"
            type="submit"
          >
            <span v-if="categoriesLoading">
              <b-spinner small type="grow"></b-spinner>
              {{ $t("app.loading") }}...
            </span>
            <span v-else>
              {{ $t("app.save") }}
            </span>
          </b-button>
          <b-button
            class="float-right mr-1"
            @click="$bvModal.hide('modal-categories')"
            variant="outline-danger"
            type="reset"
          >
            {{ $t("app.cancel") }}
          </b-button>
        </div>
      </form>
    </ValidationObserver>
  </b-modal>
</template>
<script>
import { core } from "@/config/pluginInit";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "modalForm",
  mounted() {
    core.index();
  },
  data() {
    return {
      data: {
        id: null,
        name: null,
      },
    };
  },
  methods: {
    ...mapActions({
      saveForm: "storeCategory",
    }),
    async show(item) {
      this.reserForm();
      if (item) {
        this.data = {
          id: item.id,
          name: item.name,
        };
      }
      this.$bvModal.show("modal-categories");
    },
    async onSubmit() {
      let payload = {
        id: this.data.id,
        name: this.data.name,
      };
      const resp = await this.saveForm(payload);
      this.$bvModal.hide("modal-categories");
      this.$emit("refresh");
      if (resp.status === 201 || resp.status === 200) {
        core.showSnackbar(
          "success",
          !this.data.id
            ? this.$t("app.success-create")
            : this.$t("app.success-edit")
        );
      }
      this.reserForm();
    },
    reserForm() {
      this.data = {
        id: null,
        name: null,
      };
    },
  },
  computed: {
    ...mapGetters({
      categoriesLoading: "categoriesLoading",
    }),
  },
};
</script>
